import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import Header from '@/component/header';
import Footer from '@/component/footer';
import service from '@/service/agreement';
import common from '@/util/common';
import './index.scss';
import '@/component/page';

const agreementUrlEnv = {
    dev: 'https://www-dev.lixiang.com/agreement',
    test: 'https://www-test.lixiang.com/agreement',
    testone: 'https://www-testone.lixiang.com/agreement',
    ontest: 'https://www-ontest.lixiang.com/agreement',
    prod: 'https://www.lixiang.com/agreement'
};
const agreementName = common.getQueryStringByName('name');

class App extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            isAgree: false,
            agreementUrl: '',
            hasFooter: false
        };
    }

    public componentDidMount() {
        this.agreementInit();
        if (!agreementName) {
            this.getAgreeStatus();
        }
    }

    public render() {
        return (
            <>
                <Header isAgreement={!agreementName} />
                <div className="chj-content">
                    <div
                        className={`agreement-content ${
                            !agreementName ? 'no-footer' : ''
                        }`}>
                        <iframe
                            className="agreement"
                            src={this.state.agreementUrl}
                        />
                    </div>
                    {!this.state.hasFooter && (
                        <div className="lock-bottom">
                            <div className="lock-bottom-active">
                                <div className="lock-bottom-inner">
                                    <div
                                        className="lock-bottom-left"
                                        onClick={() => this.agreeToggle()}>
                                        <div
                                            className={
                                                this.state.isAgree
                                                    ? 'confirm-agreement-select active'
                                                    : 'confirm-agreement-select'
                                            }>
                                            <i className="iconfont iconfont-select-small2" />
                                        </div>
                                        <div className="confirm-agreement-text">
                                            已阅读并同意
                                        </div>
                                    </div>
                                    <div className="btn-content">
                                        <a
                                            className="lock-button cancel"
                                            href="/">
                                            取消
                                        </a>
                                        <p
                                            className={`lock-button ${
                                                !this.state.isAgree
                                                    ? 'disabled'
                                                    : ''
                                            }`}
                                            onClick={() => this.submit()}>
                                            确定
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {agreementName && <Footer />}
            </>
        );
    }

    private agreeToggle() {
        this.setState({
            isAgree: !this.state.isAgree
        });
    }

    private submit() {
        if (this.state.isAgree) {
            this.setAgreeStatus();
        }
    }

    private setAgreeStatus() {
        service.setAgreeStatus().then(res => {
            if (res.success) {
                this.goAutoInfo();
            }
        });
    }

    private getAgreeStatus() {
        service.getAgreeStatus().then(res => {
            if (res.success && res.data.isReadAgreements) {
                this.goAutoInfo();
            }
        });
    }

    private goAutoInfo() {
        window.location.href = '/autoinfo/index.html';
    }

    private agreementInit() {
        const win: any = window;
        // @ts-ignore
        const origin = agreementUrlEnv[win.globalData.env];
        if (agreementName) {
            const link = `${origin}/${agreementName}.html?headHidden=true`;
            this.setState({
                agreementUrl: link,
                hasFooter: true
            });
        } else {
            // 默认是服务协议
            const link = `${origin}/vehicle-maintenance.html?headHidden=true`;
            // TODO: 本地开发调试
            // const link = 'http://localhost:20120/agreement/vehicle-maintenance.html?headHidden=true';
            this.setState({
                agreementUrl: link,
                hasFooter: false
            });
        }
    }
}

ReactDOM.render(<App />, document.getElementById('app'));
